module.exports = __webpack_public_path__ + "static/media/legend_heatmap_h.2085eaca.png";